export var WorkOrderSource;
(function (WorkOrderSource) {
    WorkOrderSource[WorkOrderSource["\u5FAE\u4FE1\u670D\u52A1\u53F7"] = 0] = "\u5FAE\u4FE1\u670D\u52A1\u53F7";
    WorkOrderSource[WorkOrderSource["\u5BA2\u670D\u70ED\u7EBF"] = 1] = "\u5BA2\u670D\u70ED\u7EBF";
    WorkOrderSource[WorkOrderSource["\u96C6\u56E2400\u7535\u8BDD"] = 2] = "\u96C6\u56E2400\u7535\u8BDD";
    WorkOrderSource[WorkOrderSource["\u73B0\u573A\u63A5\u5F85"] = 3] = "\u73B0\u573A\u63A5\u5F85";
    WorkOrderSource[WorkOrderSource["\u533A\u57DF400\u7535\u8BDD"] = 4] = "\u533A\u57DF400\u7535\u8BDD";
    WorkOrderSource[WorkOrderSource["\u5C0F\u60A6"] = 5] = "\u5C0F\u60A6";
})(WorkOrderSource || (WorkOrderSource = {}));
export var WorkOrderType;
(function (WorkOrderType) {
    WorkOrderType[WorkOrderType["\u54A8\u8BE2\u5DE5\u5355"] = 0] = "\u54A8\u8BE2\u5DE5\u5355";
    WorkOrderType[WorkOrderType["\u6295\u8BC9\u5DE5\u5355"] = 1] = "\u6295\u8BC9\u5DE5\u5355";
    WorkOrderType[WorkOrderType["\u62A5\u4FEE\u5DE5\u5355"] = 2] = "\u62A5\u4FEE\u5DE5\u5355";
})(WorkOrderType || (WorkOrderType = {}));
